import React from "react"
import { T } from "../../traks"
import { Card, Row, Col } from "reactstrap";

export const PremiumFeatures = () => {
  return (
    <React.Fragment>
    {/* Game setups */}
    <div className="mt-5">
      <h1 className="mb-5 fw_900 txt-45px">
        <T>Complete feature overview</T>
      </h1>

      <Row className="mb-3">
        <h3 className="feature-table-title col-6"><T>Game setups</T></h3>
        <h3 className="feature-table-title col-3 text-center"><T>Free</T></h3>
        <h3 className="feature-table-title col-3 text-center"><T>Premium</T></h3>
      </Row>
      

      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Number of invitations</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Up to 30</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Possibility for more than 30</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Game length</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Unlimited</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Unlimited</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Choose starting capital</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Unlimited</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Unlimited</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Option for max amount in a security</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Option for commission on trades</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Option for trading volume</T>
            <div className="small text-muted mt-1">
              <T>Ensures your participants can't cheat by making trades follow the volume on the stock market</T>
            </div>
          </Col>
          <Col className="text-center text-danger fw_900">
            <T>No</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Option for risk-adjusted return</T>
            <div className="small text-muted mt-1">
              <T>The return is weighted against the participant's risk. Who can win with the lowest possible risk?</T>
            </div>
          </Col>
          <Col className="text-center text-danger fw_900">
            <T>No</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
        </Row>
      </Card>
      <Card className="bg-white no-border-color border-radius-10 p-3 mb-3">
        <Row className="flex-nowrap">
          <Col className="fw_900" lg={6}>
            <T>Option for trading limit</T>
            <div className="small text-muted mt-1">
              <T>Ensures your participants can't day trade in your game</T>
            </div>
          </Col>
          <Col className="text-center text-danger fw_900">
            <T>No</T>
          </Col>
          <Col className="text-center premium-green fw_900">
            <T>Yes</T>
          </Col>
        </Row>
      </Card>
    </div>

    {/* Investment Opportunities */}
    <div className="mt-5">
      <div className="mb-3">
        <Row className="mb-3">
            <h3 className="feature-table-title col-6"><T>Investment opportunities</T></h3>
            <h3 className="feature-table-title col-3 text-center"><T>Free</T></h3>
            <h3 className="feature-table-title col-3 text-center"><T>Premium</T></h3>
          </Row>

          <div className="small mb-3">
            <T>
              As an investor, it is important to diversify your risk. With premium, you can ensure your participants have the best opportunity to create a diverse portfolio.
            </T>
          </div>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Danish stocks</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>US stocks</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>German stocks</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Swedish stocks</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Icelandic stocks</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Finnish stocks</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>ETFs</T></Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Mutual funds</T></Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Crypto</T></Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Bonds</T></Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Commodities</T></Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Addition of information and financial statements</T>
                <div className="small text-muted mt-1">
                  <T>
                    Ensures your participants have a better starting point to make more qualified decisions
                  </T>
                </div>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
        </div>

        {/* User Management */}
        <div className="mt-5">
          <Row className="mb-3">
            <h3 className="feature-table-title col-6"><T>User management</T></h3>
            <h3 className="feature-table-title col-3 text-center"><T>Free</T></h3>
            <h3 className="feature-table-title col-3 text-center"><T>Premium</T></h3>
          </Row>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Team module</T>
                <div className="small text-muted mt-1">
                  <T>Participants can join both as individuals and as a team host.</T>
                </div>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Remove unwanted participants</T>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Option for registration deadline</T>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Payout / deduct capital</T>
                <div className="small text-muted mt-1">
                  <T>The administrator can pay out or deduct capital from the participants' own portfolios.</T>
                </div>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Anonymize your users</T>
                <div className="small text-muted mt-1">
                  <T>Users can be anonymized. Contact info@aktiespilnyt.dk.</T>
                </div>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}>
                <T>Give participants insight into each other's investments</T>
                <div className="small text-muted mt-1">
                  <T>Let participants see how much and where others have invested in their portfolios.</T>
                </div>
              </Col>
              <Col className="text-center text-danger fw_900"><T>No</T></Col>
              <Col className="text-center premium-green fw_900"><T>Yes</T></Col>
            </Row>
          </Card>
        </div>

        {/* Support & Flexibility */}
        <div className="mt-5 mb-5">
          <Row className="mb-3">
            <h3 className="feature-table-title col-6"><T>Support & flexibility</T></h3>
            <h3 className="feature-table-title col-3 text-center"><T>Free</T></h3>
            <h3 className="feature-table-title col-3 text-center"><T>Premium</T></h3>
          </Row>

          <Card className="bg-white no-border-color border-radius-10 p-3 mb-2">
            <Row className="flex-nowrap">
              <Col className="fw_900" lg={6}><T>Support</T></Col>
              <Col className="text-center text-danger fw_900"><T>Email</T></Col>
              <Col className="text-center premium-green fw_900"><T>Phone</T></Col>
            </Row>
          </Card>
        </div>
    </div>
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumFeatures.js